<button
  *ngFor="let item of companyFlagHistoryComposites$ | async"
  class="flag-button me-1"
  [tooltip]="'company_flag.' + item.company_flag_type.company_flag_type_key | translate"
  [adaptivePosition]="false"
  placement="top">
  <nk-company-flag-icon
    class="d-inline-block me-1"
    size="xs"
    [companyFlagCategoryKey]="item.company_flag_type.company_flag_category_key"
    [companyFlagTypeAppIconUuid]="item.company_flag_type.app_icon_uuid"></nk-company-flag-icon>
</button>
